// #region Imports
import { Link } from "react-router";
import Avaibility from "./Avaibility";
// #endregion

const navItems = [
    {
        type: "external",
        title: "GitHub",
        href: "https://github.com/VisShon",
        newTab: true,
    },
    {
        type: "external",
        title: "Behance",
        href: "https://behance.net/visshon",
        newTab: true,
    },
    {
        type: "external",
        title: "LinkedIn",
        href: "https://www.linkedin.com/in/visshon/",
        newTab: true,
    },
    {
        type: "external",
        href: "/resume.pdf",
        title: "Resume",
        newTab: true,
    }
];

function Navbar() {
  return (
    <nav className="absolute top-0 text-[1em] z-50 small:text-[1em] font-mada flex w-full px-10 small:px-5 py-7 justify-between items-start">
      <section className="flex small:gap-0 gap-8 justify-between font-normal text-charcoal relative small:flex-col-reverse">

        {navItems.map((item) =>
          item.type === "internal" ? (
            <Link
              className="hover:text-grey transition-colors"
              key={item.to}
              to={item.to}
              title={item.title}
            >
              {item.title}
            </Link>
          ) : (
            <a
              className="hover:text-grey transition-colors"
              key={item.href}
              href={item.href}
              title={item.title}
              target={item.newTab ? "_blank" : "_self"}
              rel={item.newTab ? "noreferrer" : undefined}
            >
              {item.title}
            </a>
          ),
        )}
      </section>

      <Avaibility />
    </nav>
  );
}

export default Navbar;
